import isEmpty from 'ramda/es/isEmpty';


/**
 * Разрешена регистрация. Это же ипользуется
 * как определение дилера С. Петербурга
 */

const getRegAvailable = (state) => {
  const rtypes = state.dealer.parentRegistrationTypes;
  return (
    !!(rtypes && !isEmpty(rtypes))
  );
};

export default getRegAvailable;
